import type { CreateReturnRequestDto } from "@babackapp/private-api-client/generated/schema";
import type { ReturnDraft } from "../types";

export function buildReturnRequestPayload(draft: ReturnDraft): CreateReturnRequestDto {
  const isRetractation = draft.returnMode === "retractation";

  return {
    orderId: draft.orderId,
    shopId: draft.shopId,
    isPaidReturn: !!draft.paymentIntentId,
    withShippingLabel: isRetractation ? false : (draft.withShippingLabel ?? true),
    isRetractation: isRetractation || undefined,
    lineItems: draft.lineItems.map((li) => ({
      lineItemId: li.lineItemId,
      quantity: li.quantity,
      reasonId: li.reasonId ?? "",
      resolution: (li.resolution ?? "refund") as CreateReturnRequestDto["lineItems"][number]["resolution"],
      newVariantId: li.exchangeVariantId ?? undefined,
      comment: li.comment ?? undefined,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      customerImages: (li.imageUrls.length ? li.imageUrls.map((url) => ({ id: url, name: url, size: "0", url })) : []) as any,
    })),
    returnStoreId: draft.storeId ?? undefined,
    shippingAddress: draft.address!,
    pickingTiming: draft.pickupDate
      ? { pickupTimeStart: 0, pickupTimeEnd: 0, instruction: draft.pickupDate }
      : undefined,
    intentId: draft.paymentIntentId ?? undefined,
    newArticles: draft.rebuyItems?.length
      ? (draft.rebuyItems.map((item) => ({
          id: String(item.variantId),
          variantId: String(item.variantId),
          quantity: item.quantity,
          price: item.price / 100,
          title: item.title,
          image: item.image ?? null,
          sku: item.sku,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        })) as any)
      : undefined,
    rebuyRemainingCreditMethod: draft.rebuyRemainingCreditMethod ?? undefined,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    paidReturnMethod: (draft.paidReturnMethod ?? undefined) as any,
    shippingLine: (!isRetractation && draft.shippingRateId && draft.shippingRateTitle
      ? {
          code: draft.shippingRateId,
          title: draft.shippingRateTitle,
          price: String((draft.shippingRateAmount ?? 0) / 100),
        }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      : undefined) as any,
    notifications: { consumerEnabled: draft.notifyCustomer ?? true },
  };
}
